import { Component, component } from 'lib/component';

@component({
    selector: 'site-root',
    templateUrl: 'site.component.html',
    stylesUrl: 'site.component.scss'
})
export class App extends Component { }
